
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"6","viewBox":"0 0 10 6","width":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M5.558 5.76L5 5.182l-.558.578a.77.77 0 001.116 0zM5 4.025L1.348.24A.77.77 0 00.23.24a.84.84 0 000 1.157l4.21 4.363L5 5.182l.558.578 4.21-4.363a.84.84 0 000-1.157.77.77 0 00-1.116 0z","fill":"#8b939f","fill-rule":"evenodd"}})])
          )
        }
      }
    